/**
 * Aviso de SESSÃO EXPIRADA — o elo entre a camada de rede e a tela.
 *
 * `turbopro.ts` tenta o refresh; se falhar, limpa o token e precisa avisar
 * alguém — mas não pode ser um `navigate` direto, porque este módulo é a
 * camada de rede (Model) e não conhece React nem router. Ele avisa; quem
 * escuta é um componente do shell, que mostra o aviso e leva ao login quando
 * o usuário confirmar.
 *
 * Dispara UMA vez por sessão: numa tela com várias consultas em paralelo,
 * todas falhariam juntas, e vários avisos empilhados seriam pior que nenhum.
 * O sinal só volta a valer depois de `rearmarSessaoExpirada()`, que o login
 * chama.
 */

type Ouvinte = () => void;

const ouvintes = new Set<Ouvinte>();
let jaAvisou = false;

/** Assina o aviso. Devolve a função de cancelamento (para o `useEffect`). */
export function aoExpirarSessao(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}

/**
 * Anuncia que a sessão morreu e não deu para renovar.
 *
 * Chamado só quando o REFRESH falha — um 401 isolado com refresh bem-sucedido
 * é caminho normal e não avisa ninguém.
 */
export function anunciarSessaoExpirada(): void {
  if (jaAvisou) return;
  jaAvisou = true;
  for (const ouvinte of ouvintes) ouvinte();
}

/** Volta a permitir o aviso. O login chama depois de autenticar. */
export function rearmarSessaoExpirada(): void {
  jaAvisou = false;
}

/** Só para teste: estado do disparo único. */
export function sessaoJaAvisada(): boolean {
  return jaAvisou;
}
